










































import { Vue } from "vue-property-decorator";

export default {
    name: 'ContactComponent',
    data: () => ({
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      thanksOverlayClass: 'thanks-overlay--hidden'
    }),
    methods: {
      encode(data: any) {
        return Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
      },
      handleSubmit() {
        fetch('/', {
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: this.encode({
            'form-name': 'contact-form',
            ...this.form
          })
        }).then(() => this.openThanksOverlay())        
        .catch(e => console.error(e))
      },
      openThanksOverlay() {
        this.thanksOverlayClass = "thanks-overlay";
      },
      closeOverlay() {        
        this.thanksOverlayClass = "thanks-overlay--hidden";
      },
      resetForm() {
        this.form.name = '';
        this.form.email = '';
        this.form.subject = '';
        this.form.message = '';
      }
    }
}
